import { CommonModule } from '@angular/common';
import {
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  input,
  output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconNameType } from '../../../../shared/icons/icon-name-type.enum';
import { IconComponent } from '../../../../shared/icons/icon.component';
import { OrderableQualifier } from '../../../models/menu/orderable-qualifier.model';
import { TranslocoModule } from '@ngneat/transloco';
import { ConfigService } from '../../../services/config.service';
@Component({
  selector: 'cwo-qualifier',
  standalone: true,
  imports: [CommonModule, FormsModule, IconComponent, TranslocoModule],
  templateUrl: './qualifier.component.html',
  styleUrl: './qualifier.component.scss',
})
export class QualifierComponent implements OnInit, OnChanges{
  displayStyle = input<'flatten' | 'dropdown'>('flatten');
  qualifiers = input.required<OrderableQualifier[]>();
  selectedQualifiers = input.required<string[]>();
  storeConfig = inject(ConfigService).configState().store;
  widthToSet: number | undefined = undefined;
  isQualifierSelected = input<boolean>(false);
 
  readonly qualifierChange = output<{
    qualifiers: OrderableQualifier[];
    selectedQualifier?: OrderableQualifier;
}>();

  iconNameType = IconNameType;
  _selectedOther?: OrderableQualifier;
  _selectedSide?: OrderableQualifier;
  _selectedOtherName: string = '';
  private _isKeyboardNavigating = false;

  handleDropdownKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      this._isKeyboardNavigating = true;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      if (this._isKeyboardNavigating) {
        this._isKeyboardNavigating = false;
        const select = event.target as HTMLSelectElement;
        this.handleSelectChange({ target: select } as unknown as Event);
      }
    }
  }

  handleDropdownBlur(event: FocusEvent) {
    if (this._isKeyboardNavigating) {
      this._isKeyboardNavigating = false;
      const select = event.target as HTMLSelectElement;
      this.handleSelectChange({ target: select } as unknown as Event);
    }
  }

  
  ngOnInit(): void {
    this.initQualifiers();

    setTimeout(() => {      
      this.changeSelectWidth(this._selectedOtherName );
    });
  }
 
  ngOnChanges(changes: SimpleChanges): void {
     if(changes['selectedQualifiers']){
        this.initQualifiers();
        if(!this.isQualifierSelected()) this._selectedOther = undefined;
      
      this.changeSelectWidth(this._selectedOtherName);
     }
  }

  initQualifiers() {
    this._selectedOtherName = '';
    this._selectedOther = undefined;
    this._selectedSide = this.selectedQualifiers().some((sq) => sq === 'Side')
    ? this.qualifiers().find((q) => q.name === 'Side') ?? undefined
    : undefined;

    const selectedOtherQualifiers = this.selectedQualifiers().filter(q => q !== 'Side')
    if(selectedOtherQualifiers.length) {
      this._selectedOther =  this.qualifiers().find((q) => q.name === selectedOtherQualifiers[0]);
      this._selectedOtherName = this._selectedOther?.name ?? ''
    }
  }

  getOtherQualifiers() {
    return this.qualifiers().filter((q) => q.name !== 'Side');
  }

  getSideQualifier() {
    return this.qualifiers().filter((q) => q.name === 'Side');
  }

  onOtherSelectionChange(value?: OrderableQualifier) {
    this._selectedOther = value;
    this.emitQualifierChange(value);
  }

  onSideSelectionChange(value: OrderableQualifier) {
    this._selectedSide =  this._selectedSide === value ? undefined : value;
    this.emitQualifierChange(value);
  }

  emitQualifierChange(selectedQual?: OrderableQualifier) {
    this.qualifierChange.emit({
      qualifiers: [this._selectedOther, this._selectedSide].filter(Boolean) as OrderableQualifier[], 
      selectedQualifier: selectedQual
    });
  }

  handleSelectChange(event: Event) {
    if (this._isKeyboardNavigating) {
      return;
    }
    const value = (event.target as HTMLSelectElement).value;
    const qualifierName = value === 'clear' ? '' : value;
    const qualifier = this.qualifiers().find((q) => q.name === qualifierName);
    this._selectedOtherName = qualifier?.name ?? ''
    this.onOtherSelectionChange(qualifier);

    this.changeSelectWidth(value);
  }

  changeSelectWidth(value: any) {
    const selectDropdown = document.getElementById("qualifier-dropdown-select");
    
    if(selectDropdown) {
      const font = window.getComputedStyle(selectDropdown).font;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      
      if(context?.font) {
        context.font = font;
      }

      if(!value) {
        if(this.storeConfig?.xtraLabel) {
          const textWidth = context?.measureText(this.storeConfig?.xtraLabel).width;
          this.widthToSet = (textWidth ? textWidth + 60 : textWidth) ?? 0;
        } else {
          this.widthToSet = undefined;
        }
      } else {
        const textWidth = context?.measureText(value ?? '').width;
        this.widthToSet = (textWidth ? textWidth + 60 : textWidth) ?? 0;
      }
    } 
  }

  handleOtherSelectionChange(value: OrderableQualifier) {
    if(this._selectedOther?.name === value.name) {
      this.onOtherSelectionChange(undefined);
    } else {
      const qualifier = this.qualifiers().find((q) => q.name === value.name);
      this.onOtherSelectionChange(qualifier);
    }
  }
}
